import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook que lista proyectos.
 * Por default solo desarrollos activos (es_desarrollo=1 + Ciudad del Valle).
 * Pasar todos=true para los 14 proyectos completos.
 */
export function useProyectos(todos = false) {
  return useQuery({
    queryKey: ['proyectos', todos],
    queryFn: () => cliente.proyectos.listar(todos),
    // Cambia muy poco (viene del ETL) y la consulta toca vw_obras (lenta) →
    // cacheamos largo para no re-pedirla en cada navegación.
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
  });
}
